import * as React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const FooterForm = ({ id, globals, shop, settings, list_links, type }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    return (
        <div className={'form bg-[#FBF8F4] p-[32px]'}>

            <div className={'flex justify-between mx-2 mb-3'}>
                <p className={'b_alt text-black'}>Ready to partner?</p>
                <p className={'b_alt text-black'}>Enquiry Form</p>
            </div>
            <iframe
                className={`form-iframe`}
                height={isMobile ? '1050px' : '800px'}
                width={isMobile ? '100%' : '450px'}
                src="https://www-mindarc-com.filesusr.com/html/0e7dc4_7edce621ab64d0d4a7ea60feeed745cd.html"
                frameBorder="0">

            </iframe>
        </div>
    );
};
